import { render, staticRenderFns } from "./FiledConsentJudgment.vue?vue&type=template&id=9528ba1c&scoped=true&"
import script from "./FiledConsentJudgment.vue?vue&type=script&lang=js&"
export * from "./FiledConsentJudgment.vue?vue&type=script&lang=js&"
import style0 from "./FiledConsentJudgment.vue?vue&type=style&index=0&id=9528ba1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9528ba1c",
  null
  
)

export default component.exports